import { useEffect } from 'react';

import { LoadingSpinner } from '../LoadingSpinner/LoadingSpinner';

/**
 * Login now lives in sampark-new at /app/login. Both apps are served from one
 * origin (see firebase.json: sampark-new is mounted at /app/**), but they are
 * separate bundles, so this must be a full page load rather than a react-router
 * transition — same reasoning as `newAppUrl` in constants/routes.ts.
 *
 * `replace` (not `assign`) keeps the dead legacy /auth entry out of history, so
 * Back from the new login page does not bounce the user straight back here.
 */
export const RedirectToNewLogin = () => {
  useEffect(() => {
    window.location.replace('/app/login');
  }, []);

  return <LoadingSpinner />;
};
